// extracted by mini-css-extract-plugin
module.exports = {"pintxo-skeleton":"Skeleton_pintxo-skeleton__yVbyZ","pintxo-skeleton-shape":"Skeleton_pintxo-skeleton-shape__AlbEa","fill-animation":"Skeleton_fill-animation__Bx3OJ"};